var React = require('react');

function ArrowSmallRight (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"points":"2.5 2.5 8.5 8.5 2.5 14.51","style":{"fill":"none","stroke":"#fff100","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"5px"}}));
}

ArrowSmallRight.defaultProps = {"viewBox":"0 0 11 17.01"};

module.exports = ArrowSmallRight;

ArrowSmallRight.default = ArrowSmallRight;
